/* eslint-disable react/button-has-type */
import Card, { Actions, ActionIcons } from '../MDC/Card/Card';
import { Headline4 } from '@material/react-typography';
import DeleteSelection from '../../AppCart/GenericApps/GenericFunctions/DeleteSelection.js';

// var querystring = require("querystring");

import classes from './GenericForm.module.scss';
// const STYLE_FORM_DEFAULT = 'generic-form';
const STYLE_CARD_DEFAULT = 'mdc-card--app';

const genericForm = props => {
	/**
	 *
	 */
	return (
		<Card
			xlarge
			className={classes[STYLE_CARD_DEFAULT]}
			style={props.style}
		>
			<div className={classes['flex-container']}>
				<Headline4>{props.name}</Headline4>
				<Actions>
					<ActionIcons>
						<DeleteSelection appId={props.appId}/>
					</ActionIcons>
				</Actions>
			</div>
			{props.children}
		</Card>
	);
};

export default genericForm;
